import StoryblokLink from "../../components/link/StoryblokLink";
import SBEditable from "../../components/sbEditable/sbEditable";
import StoryblokImageBasic from "../../components/storyblokImageBasic/storyblokImageBasic";
import { RightArrowSVG } from "../../svg";
import styles from "./storeProduct.module.scss";

function StoreProduct({ blok }) {
  return (
    <SBEditable withClass={styles.root} blok={blok}>
      <StoryblokLink linkObject={blok.link} className={styles.imageContainer}>
        <StoryblokImageBasic image={blok.image} width={160} height={160} />
      </StoryblokLink>
      <div className={styles.rightSide}>
        <StoryblokLink linkObject={blok.link} className={styles.name}>
          {blok.name}
        </StoryblokLink>
        <h3 className={styles.price}>{blok.price}</h3>
        <StoryblokLink
          linkObject={blok.link}
          className={`${styles.button} ${blok.button_color}`}
        >
          {blok.button_text}
          <span className={styles.rightArrowSVG}>
            <RightArrowSVG />
          </span>
        </StoryblokLink>
      </div>
    </SBEditable>
  );
}

export default StoreProduct;
